export const translations = {
  es: {
    hero: {
      title: 'Planes que se adaptan a tus necesidades',
      subtitle: 'Elige el plan perfecto para tu desarrollo profesional'
    },
    plans: {
      free: {
        name: 'Plan Gratuito',
        badge: 'Beta',
        description: 'Perfecto para comenzar tu viaje de aprendizaje y explorar las funcionalidades básicas de Cortex AI.',
        price: 'Gratis',
        period: '',
        features: [
          'Mentor IA básico con feedback limitado',
          '5 tareas mensuales con evaluación IA',
          '1 certificación IA verificada',
          'Acceso al foro de la comunidad'
        ],
        cta: 'Empezar gratis',
        trial: 'Sin compromiso, cancela cuando quieras'
      },
      pro: {
        name: 'Plan Pro',
        badge: 'Acceso Anticipado',
        description: 'Para profesionales comprometidos con su desarrollo que buscan una experiencia de aprendizaje completa.',
        price: '49,99€',
        period: '/mes',
        priceNote: 'Precio especial de lanzamiento (después 79,99€/mes)',
        features: [
          'Todo lo del plan gratuito',
          'Mentor IA avanzado con feedback detallado 24/7',
          'Tareas y proyectos ilimitados con evaluación IA',
          'Certificaciones IA ilimitadas y verificadas',
          'Portfolio profesional generado por IA',
          'Simulaciones avanzadas de toma de decisiones'
        ],
        cta: 'Comenzar plan pro',
        trial: 'O prueba 7 días gratis'
      },
      premium: {
        name: 'Plan Premium',
        badge: 'Coaching Avanzado',
        description: 'Coaching personalizado, certificaciones blockchain y acceso a oportunidades laborales exclusivas.',
        price: '99,99€',
        period: '/mes',
        priceNote: 'O 799€ pago único (Bootcamp intensivo)',
        features: [
          'Todo lo del plan pro',
          'Certificaciones verificadas en blockchain',
          'Acceso a mentores humanos expertos',
          'Oportunidades laborales exclusivas',
          'Portfolio premium con ranking IA'
        ],
        cta: 'Comenzar plan premium',
        info: 'Solicitar más información'
      }
    },
    comparison: {
      title: 'Comparativa detallada de planes',
      features: {
        aiMentor: 'Mentor IA',
        monthlyTasks: 'Tareas mensuales',
        aiCertifications: 'Certificaciones IA',
        aiPortfolio: 'Portfolio IA',
        simulations: 'Simulaciones',
        skillVerification: 'Verificación de habilidades',
        jobOpportunities: 'Oportunidades laborales'
      },
      levels: {
        basic: 'Básico',
        advanced: 'Avanzado',
        premium: 'Premium + Humano',
        limited: '5',
        unlimited: 'Ilimitadas',
        one: '1',
        blockchain: 'Blockchain',
        none: '-',
        yes: '✓',
        exclusive: 'Exclusivas'
      }
    },
    faq: {
      title: 'Preguntas frecuentes',
      support: {
        text: '¿No encuentras la respuesta que buscas? Contacta con nuestro',
        link: 'equipo de soporte'
      },
      questions: [
        {
          title: '¿Cómo funciona la verificación de habilidades por IA?',
          answer: 'Nuestra IA evalúa tu trabajo en proyectos reales, analizando tu código, decisiones y resultados. Cada habilidad se verifica a través de múltiples proyectos y desafíos, asegurando una evaluación objetiva y precisa.'
        },
        {
          title: '¿Qué son las certificaciones blockchain?',
          answer: 'Las certificaciones blockchain son credenciales verificables e inmutables que demuestran tus habilidades. Cada certificación incluye un registro detallado de los proyectos y evaluaciones que la respaldan.'
        },
        {
          title: '¿Cómo me ayuda el portfolio generado por IA?',
          answer: 'El portfolio IA organiza y presenta tus proyectos, habilidades y logros de manera profesional. La IA destaca tus fortalezas y proporciona métricas objetivas de tu impacto y capacidades.'
        }
      ]
    },
    cta: {
      title: '¿Listo para transformar tu carrera?',
      subtitle: 'Comienza tu viaje con CortexAI hoy.',
      buttons: {
        start: 'Empezar gratis',
        sales: 'Contactar ventas'
      }
    }
  },
  en: {
    hero: {
      title: 'Plans that adapt to your needs',
      subtitle: 'Choose the perfect plan for your professional development'
    },
    plans: {
      free: {
        name: 'Free Plan',
        badge: 'Beta',
        description: 'Perfect for starting your learning journey and exploring the basic features of Cortex AI.',
        price: 'Free',
        period: '',
        features: [
          'Basic AI mentor with limited feedback',
          '5 monthly tasks with AI evaluation',
          '1 verified AI certification',
          'Access to community forum'
        ],
        cta: 'Start for free',
        trial: 'No commitment, cancel anytime'
      },
      pro: {
        name: 'Pro Plan',
        badge: 'Early Access',
        description: 'For professionals committed to their development who seek a complete learning experience.',
        price: '$49.99',
        period: '/month',
        priceNote: 'Special launch price (later $79.99/month)',
        features: [
          'Everything in the free plan',
          'Advanced AI mentor with detailed 24/7 feedback',
          'Unlimited tasks and projects with AI evaluation',
          'Unlimited verified AI certifications',
          'AI-generated professional portfolio',
          'Advanced decision-making simulations'
        ],
        cta: 'Start Pro plan',
        trial: 'Or try 7 days free'
      },
      premium: {
        name: 'Premium Plan',
        badge: 'Advanced Coaching',
        description: 'Personalized coaching, blockchain certifications, and access to exclusive job opportunities.',
        price: '$99.99',
        period: '/month',
        priceNote: 'Or $799 one-time payment (Intensive Bootcamp)',
        features: [
          'Everything in the Pro plan',
          'Blockchain-verified certifications',
          'Access to expert human mentors',
          'Exclusive job opportunities',
          'Premium portfolio with AI ranking'
        ],
        cta: 'Start Premium plan',
        info: 'Request more information'
      }
    },
    comparison: {
      title: 'Detailed plan comparison',
      features: {
        aiMentor: 'AI Mentor',
        monthlyTasks: 'Monthly Tasks',
        aiCertifications: 'AI Certifications',
        aiPortfolio: 'AI Portfolio',
        simulations: 'Simulations',
        skillVerification: 'Skill Verification',
        jobOpportunities: 'Job Opportunities'
      },
      levels: {
        basic: 'Basic',
        advanced: 'Advanced',
        premium: 'Premium + Human',
        limited: '5',
        unlimited: 'Unlimited',
        one: '1',
        blockchain: 'Blockchain',
        none: '-',
        yes: '✓',
        exclusive: 'Exclusive'
      }
    },
    faq: {
      title: 'Frequently Asked Questions',
      support: {
        text: 'Can\'t find the answer you\'re looking for? Contact our',
        link: 'support team'
      },
      questions: [
        {
          title: 'How does AI skill verification work?',
          answer: 'Our AI evaluates your work on real projects, analyzing your code, decisions, and results. Each skill is verified through multiple projects and challenges, ensuring an objective and accurate assessment.'
        },
        {
          title: 'What are blockchain certifications?',
          answer: 'Blockchain certifications are verifiable and immutable credentials that demonstrate your skills. Each certification includes a detailed record of the projects and assessments that support it.'
        },
        {
          title: 'How does the AI-generated portfolio help me?',
          answer: 'The AI portfolio organizes and presents your projects, skills, and achievements professionally. The AI highlights your strengths and provides objective metrics of your impact and capabilities.'
        }
      ]
    },
    cta: {
      title: 'Ready to transform your career?',
      subtitle: 'Start your journey with CortexAI today.',
      buttons: {
        start: 'Start for free',
        sales: 'Contact sales'
      }
    }
  }
};